import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const LetsTalk = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <Typography component="h2" variant="subtitle">
        {t("footer.lets_talk")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "left",
          gap: "10px",
          width: "100%",
        }}
      >
        <Typography sx={{ display: "inline" }} variant="code1">
          {"<mail>"}
        </Typography>
        <Typography
          sx={{ display: "inline", minWidth: "230px" }}
          variant="code1"
        >
          hello@bluesbrackets.com
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "left",
          gap: "10px",
          width: "100%",
        }}
      >
        <Typography sx={{ display: "inline" }} variant="code1">
          {"<phone>"}
        </Typography>
        <Typography
          sx={{ display: "inline", minWidth: "230px" }}
          variant="code1"
        >
          +48 535 462 678
        </Typography>
      </Box>
    </Box>
  );
};
